import { render, staticRenderFns } from "./viewDesc.vue?vue&type=template&id=0a4bbcf0&scoped=true&"
import script from "./viewDesc.vue?vue&type=script&lang=js&"
export * from "./viewDesc.vue?vue&type=script&lang=js&"
import style0 from "./viewDesc.vue?vue&type=style&index=0&id=0a4bbcf0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bbcf0",
  null
  
)

export default component.exports